import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import { holidaysUrl } from './constants';

export default function prefetchHolidays(client: APIClient) {
  prefetchQuery(holidaysUrl, client, {});
}
